/**
 * LED-SCHILD CONFIGURATOR ENGINE
 * State machine for 2-path product configuration
 */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        const root = document.getElementById('LscConfigurator');
        if (!root) return;
        console.log('LSC Configurator initialized');

        /* ═══ STATE ═══ */
        const config = {
            step: 1,
            path: 'A', // 'A' (Farbdruck) or 'B' (Plottfolie)
            beleuchtungsart: 'Farbdruck',
            leuchtVariante: null,
            leuchtVarianteKey: null, // 'motiv' | 'hintergrund' — drives the preview image
            folieFarbe: null,
            designQuelle: 'upload',
            designFile: null,
            designNote: '',
            variantMap: JSON.parse(root.querySelector('#LscVariantMap').textContent),
            logoDesignId: root.dataset.logoDesignId || null,
            logoDesignPrice: 9900, // 99€ in cents
        };

        /* ═══ DOM REFS ═══ */
        const $ = (s) => root.querySelector(s);
        const $$ = (s) => root.querySelectorAll(s);

        const dom = {
            title: $('#LscTitle'),
            hint: $('#LscHint'),
            dots: $$('.lsc__step-dot'),
            lines: $$('.lsc__step-line'),
            steps: $$('.lsc__step'),
            next: $('#LscNext'),
            prev: $('#LscPrev'),
            // Gallery
            mainImage: $('#LscMainImage'),
            thumbs: $$('.lsc__gallery-thumb'),
            // Color picker
            colorAccordion: $('#LscColorAccordion'),
            toggleMoreColors: $('#LscToggleMoreColors'),
            // Inputs
            form: $('#LscForm'),
            fileInput: $('#LscFile'),
            noteInput: $('#LscNote'),
            // Hidden cart properties
            props: {
                beleuchtungsart: $('#LscPropBeleuchtungsart'),
                leuchtVariante: $('#LscPropLeuchtVariante'),
                folieFarbe: $('#LscPropFolieFarbe'),
                designQuelle: $('#LscPropDesignQuelle'),
                designNote: $('#LscPropDesignNote'),
                variantId: $('#LscVariantIdInput')
            },
            hintText: $('#LscHintText')
        };

        const STEPS_A = [1, 4]; // Beleuchtungsart -> Design
        const STEPS_B = [1, 2, 3, 4]; // Beleuchtungsart -> Variant -> Color -> Design

        const HINTS = {
            default: '💡 Wählen Sie eine Option – eine Vorschau wird automatisch angezeigt.',
            typeA: '🖨️ Ihr Design wird vollflächig farbig gedruckt und gleichmäßig von innen beleuchtet.',
            typeB: '✂️ Ihr Motiv wird präzise aus einer einfarbigen Folie ausgeschnitten.',
            leuchtMotiv: '✨ Nur Ihr Logo leuchtet – der Hintergrund bleibt dunkel.',
            leuchtHintergrund: '🌟 Die gesamte Fläche leuchtet – Ihr Motiv erscheint dunkel.'
        };

        // Gallery previews per Leucht-Variante (1-based, matches the product media order):
        // `select` shows on the step-2 click, `confirm` once step 3 opens.
        const LEUCHT_PREVIEW = {
            motiv: { select: 2, confirm: 4, hint: '← Vorschau: Nur das Motiv leuchtet' },
            hintergrund: { select: 3, confirm: 5, hint: '← Vorschau: Der Hintergrund leuchtet' }
        };

        /* ═══ NAVIGATION ═══ */
        function goTo(step) {
            const currentPathSteps = config.path === 'A' ? STEPS_A : STEPS_B;

            // Find current index
            const currentIndex = currentPathSteps.indexOf(config.step);

            if (step === 'next') {
                if (currentIndex < currentPathSteps.length - 1) {
                    config.step = currentPathSteps[currentIndex + 1];
                } else {
                    addToCart();
                    return;
                }
            } else if (step === 'prev') {
                if (currentIndex > 0) {
                    config.step = currentPathSteps[currentIndex - 1];
                }
            } else {
                config.step = step;
            }

            render();
        }

        function render() {
            const s = config.step;
            const currentPathSteps = config.path === 'A' ? STEPS_A : STEPS_B;
            const stepIndex = currentPathSteps.indexOf(s) + 1;
            const totalSteps = currentPathSteps.length;

            // Titles & Hints
            const titles = {
                1: 'Wie soll dein Motiv beleuchtet werden?',
                2: 'Welche Leucht-Variante möchtest du?',
                3: 'Welche Farbe soll dein Motiv haben?',
                4: 'Wie möchtest du dein Design einreichen?'
            };
            const hints = {
                1: 'Wähle die gewünschte Beleuchtungsart für dein LED-Schild.',
                2: 'Wie soll dein Motiv beleuchtet werden?',
                3: 'Wähle die gewünschte Folienfarbe.',
                4: 'Wie möchtest du uns dein Design übermitteln?'
            };

            dom.title.textContent = titles[s] || 'Konfiguration';
            dom.hint.textContent = hints[s] || '';

            // Panels
            dom.steps.forEach(panel => {
                panel.classList.toggle('is-visible', parseInt(panel.dataset.step) === s);
            });

            // Stepper Dots (Simplified for dynamic paths: just show 1 to N based on current index)
            // But user asked for numbered dots. We'll show dots for the current path sequence.
            dom.dots.forEach((dot, i) => {
                const dotStep = i + 1;
                dot.classList.toggle('is-hidden', dotStep > totalSteps);
                dot.classList.toggle('is-active', dotStep === stepIndex);
                dot.querySelector('span').textContent = dotStep;
            });
            dom.lines.forEach((line, i) => {
                const lineIndex = i + 1;
                line.classList.toggle('is-hidden', lineIndex >= totalSteps);
            });

            // Nav
            dom.prev.classList.toggle('is-hidden', stepIndex === 1);
            dom.next.innerHTML = stepIndex === totalSteps
                ? 'In den Warenkorb <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
                : 'Weiter <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';

            // Step 3 swaps to the confirmed preview for the chosen Leucht-Variante
            if (s === 3 && config.leuchtVarianteKey) {
                const preview = LEUCHT_PREVIEW[config.leuchtVarianteKey];
                updatePreviewImage(preview.confirm);
                updateHintText(preview.hint);
            }
        }

        /* ═══ PREVIEW ═══ */
        function updatePreviewImage(position) {
            const thumb = Array.from(dom.thumbs).find(t => parseInt(t.dataset.position) === position);
            if (!thumb || !dom.mainImage) return;

            const newSrc = thumb.dataset.imageUrl;
            if (dom.mainImage.src === newSrc) return;

            // Fade out
            dom.mainImage.style.opacity = '0';

            setTimeout(() => {
                dom.mainImage.src = newSrc;
                // Fade in after src change
                dom.mainImage.onload = () => {
                    dom.mainImage.style.opacity = '1';
                };
                // Fallback if cached
                if (dom.mainImage.complete) {
                    dom.mainImage.style.opacity = '1';
                }

                // Sync thumb active state
                dom.thumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
            }, 300);
        }

        function updateHintText(text) {
            if (!dom.hintText || dom.hintText.textContent === text) return;
            dom.hintText.style.opacity = '0';
            setTimeout(() => {
                dom.hintText.textContent = text;
                dom.hintText.style.opacity = '1';
            }, 300);
        }

        /* ═══ LOGIC ═══ */
        function selectBeleuchtung(type) {
            config.beleuchtungsart = type === 'A' ? 'Vollflächiger Farbdruck' : 'Plottfolie';
            config.path = type;

            // Sync UI
            $$('.lsc__choice-card[data-beleuchtung]').forEach(c => {
                c.classList.toggle('is-selected', c.dataset.beleuchtung === type);
            });

            // Preview mapping: A -> Pos 1, B -> Pos 2
            updatePreviewImage(type === 'A' ? 1 : 2);

            // Update Hint
            updateHintText(type === 'A' ? "← Vorschau: So sieht Ihr Farbdruck-Schild aus" : "← Vorschau: So sieht Plottfolie aus");

            // Reset path B specific flags if switching to A
            if (type === 'A') {
                config.leuchtVariante = null;
                config.leuchtVarianteKey = null;
                config.folieFarbe = null;
            } else if (type === 'B') {
                const checkedColor = root.querySelector('input[name="properties[Folie Farbe]"]:checked');
                if (checkedColor) config.folieFarbe = checkedColor.value;
            }
        }

        function selectLeuchtVariante(val, label) {
            config.leuchtVariante = label;
            config.leuchtVarianteKey = val;
            $$('.lsc__choice-card[data-variante]').forEach(c => {
                c.classList.toggle('is-selected', c.dataset.variante === val);
            });

            const preview = LEUCHT_PREVIEW[val];
            updatePreviewImage(preview.select);
            updateHintText(preview.hint);
        }

        function selectFarbe(color) {
            config.folieFarbe = color;

            // Keep showing the image for the Leucht-Variante chosen in step 2
            if (config.leuchtVarianteKey) {
                updatePreviewImage(LEUCHT_PREVIEW[config.leuchtVarianteKey].confirm);
            }

            // Update Hint
            updateHintText("← Vorschau: Verschiedene Farboptionen");
        }

        function selectDesignQuelle(quelle) {
            config.designQuelle = quelle;
            $$('.lsc__choice-card[data-source]').forEach(c => {
                c.classList.toggle('is-selected', c.dataset.source === quelle);
            });
            $('#LscUploadField').classList.toggle('is-hidden', quelle !== 'upload');
        }

        function addToCart() {
            // Validate
            if (config.path === 'B') {
                if (!config.leuchtVariante) { alert('Bitte wählen Sie eine Leucht-Variante.'); return; }
                if (!config.folieFarbe) { alert('Bitte wählen Sie eine Farbe.'); return; }
            }
            if (config.designQuelle === 'upload' && !dom.fileInput.files.length) {
                alert('Bitte laden Sie eine Datei hoch oder wählen Sie eine andere Option.');
                return;
            }

            const mainVariantId = Object.values(config.variantMap)[0]?.id;
            const designQuelleText = config.designQuelle === 'design_service' ? 'Logo von uns gestalten lassen (+99€)' : (config.designQuelle === 'later' ? 'Datei später einreichen' : 'Design hochladen');

            const properties = {
                'Beleuchtungsart': config.beleuchtungsart,
                'Leucht-Variante': config.leuchtVariante || '',
                'Folie Farbe': config.folieFarbe || '',
                'Design Quelle': designQuelleText,
                'Design Hinweis': dom.noteInput.value
            };

            dom.next.disabled = true;
            dom.next.textContent = 'Wird hinzugefügt...';

            const bundleId = Date.now().toString();

            if (config.designQuelle === 'design_service' && config.logoDesignId) {
                // AJAX for multiple items (Main Product + Logo Design Item)
                properties._bundle_id = bundleId;
                properties._is_parent = 'true';

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [
                            {
                                id: mainVariantId,
                                quantity: 1,
                                properties: properties
                            },
                            {
                                id: config.logoDesignId,
                                quantity: 1,
                                properties: {
                                    _bundle_id: bundleId,
                                    _mandatory: 'true'
                                }
                            }
                        ]
                    })
                })
                    .then(res => res.json())
                    .then(() => {
                        window.location.href = '/cart';
                    })
                    .catch(err => {
                        console.error('Cart Error:', err);
                        dom.next.disabled = false;
                        dom.next.textContent = 'In den Warenkorb';
                        alert('Fehler beim Hinzufügen zum Warenkorb.');
                    });
            } else {
                // Standard form submission for file upload or simple single-item later
                dom.props.beleuchtungsart.value = properties['Beleuchtungsart'];
                dom.props.leuchtVariante.value = properties['Leucht-Variante'];
                dom.props.folieFarbe.value = properties['Folie Farbe'];
                dom.props.designQuelle.value = properties['Design Quelle'];
                if (dom.props.designNote) {
                    dom.props.designNote.value = properties['Design Hinweis'];
                }
                dom.props.variantId.value = mainVariantId;
                dom.form.submit();
            }
        }

        /* ═══ EVENT BINDINGS ═══ */
        dom.next.addEventListener('click', () => goTo('next'));
        dom.prev.addEventListener('click', () => goTo('prev'));

        $$('.lsc__choice-card[data-beleuchtung]').forEach(card => {
            card.addEventListener('click', () => selectBeleuchtung(card.dataset.beleuchtung));
        });

        $$('.lsc__choice-card[data-variante]').forEach(card => {
            card.addEventListener('click', () => selectLeuchtVariante(card.dataset.variante, card.querySelector('strong').textContent));
        });

        if (dom.toggleMoreColors) {
            dom.toggleMoreColors.addEventListener('click', () => {
                dom.colorAccordion.classList.toggle('active');
            });
        }

        root.addEventListener('change', (e) => {
            if (e.target.name === 'properties[Folie Farbe]') {
                selectFarbe(e.target.value);
            }
        });

        $$('.lsc__choice-card[data-source]').forEach(card => {
            card.addEventListener('click', () => selectDesignQuelle(card.dataset.source));
        });

        dom.thumbs.forEach(thumb => {
            thumb.addEventListener('click', () => {
                const pos = parseInt(thumb.dataset.position);
                updatePreviewImage(pos);
            });
        });

        dom.fileInput.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (file) {
                $('.lsc__dropzone span').textContent = file.name;
            }
        });

        /* ═══ INIT ═══ */
        // Sync state with the color pre-checked in the markup (Weiß)
        const preCheckedColor = root.querySelector('input[name="properties[Folie Farbe]"]:checked');
        if (preCheckedColor) config.folieFarbe = preCheckedColor.value;

        render();
    }
})();
